import styled from 'styled-components'

export default styled.div`
    overflow-y: auto;
    overflow-x: hidden;
    padding: 15px 10% 15px 10%;
    min-width: 940px;
    flex: 1;
`
